export const isNavbarInverse = state => state.navbar.inverse



/** WEBPACK FOOTER **
 ** ./src/vuex/getters.js
 **/